import { render } from "./UserMessageBody.vue.js?vue&type=template&id=6a1c1a11!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageBody.vue?vue&type=template&id=6a1c1a11"
import script from "./UserMessageBody.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageBody.vue?vue&type=script&lang=js"
export * from "./UserMessageBody.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/user-message/UserMessageBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a1c1a11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a1c1a11', __exports__)) {
    api.reload('6a1c1a11', __exports__)
  }
  
  module.hot.accept("./UserMessageBody.vue.js?vue&type=template&id=6a1c1a11!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageBody.vue?vue&type=template&id=6a1c1a11", () => {
    api.rerender('6a1c1a11', render)
  })

}


export default __exports__